import { render, staticRenderFns } from "./ScheduleTab.vue?vue&type=template&id=1ed1b01c&scoped=true&"
import script from "./ScheduleTab.vue?vue&type=script&lang=js&"
export * from "./ScheduleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1b01c",
  null
  
)

export default component.exports